import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-amber-400 text-slate-900 py-2 px-4 text-center font-bold text-sm md:text-base sticky top-0 z-50 shadow-md" data-id="element-197">
      <div className="flex items-center justify-center gap-2 max-w-7xl mx-auto" data-id="element-198">
        <AlertTriangle className="h-5 w-5 text-red-600" data-id="element-199" />
        <span data-id="element-200">
          ATENCIÓN: Esta información podría ser censurada pronto. Lee esto
          mientras esté disponible.
        </span>
      </div>
    </div>;
}